











































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  Button,
  Checkbox,
  Form,
  FormItem,
  Input,
  Option,
  Select
} from 'element-ui';

// Types
import { ShipmentFields } from '@/types/graphql/schemaTypes';

// Options
import { shipmentStatusOptions } from '@/constants/shipmentStatusOptions.ts';

// GQL
import updateShipment from '@/graphql/mutations/ShipmentUpdate.gql';

// Utils
import { statusColor } from '@/utilities/textUtils';

@Component({
  components: {
    'el-button': Button,
    'el-checkbox': Checkbox,
    'el-form-item': FormItem,
    'el-form': Form,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class Status extends Vue {
  @Prop({ required: true, type: Object }) shipmentStatus;

  // Data
  isLoading = false;
  shipmentStatusOptions = shipmentStatusOptions();

  statusInput = {
    status: this.shipmentStatus.status || 'shipment_preparing',
    statusComment: this.shipmentStatus.statusComment || '',
    isProblem: this.shipmentStatus.isProblem || false
  };

  private statusColor(): string {
    return statusColor(this.shipmentStatus);
  }

  async submit() {
    this.isLoading = true;

    try {
      const response = await this.$apollo.mutate({
        mutation: updateShipment,
        variables: {
          shipmentUpdateArgs: {
            id: this.shipmentStatus.id,
            status: this.statusInput.status,
            statusComment: this.statusInput.statusComment,
            isProblem: this.statusInput.isProblem
          }
        }
      });

      if (response) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.$emit('refresh');
      this.isLoading = false;
    }
  }

  @Watch('shipmentStatus', { deep: true })
  refreshStatusInput() {
    this.statusInput = {
      status: this.shipmentStatus.status || 'shipment_preparing',
      statusComment: this.shipmentStatus.statusComment || '',
      isProblem: this.shipmentStatus.isProblem || false
    };
  };
}
